module.exports = __webpack_public_path__ + "static/media/1 tiger samurai cherryblossom hanya mask leg sleeve black and grey.1280x1480.b964ef51.webp";